"use client";

import { useEffect, useRef, useState } from "react";

export function useTween(
  target: number,
  { duration = 700, from }: { duration?: number; from?: number } = {},
): number {
  const [value, setValue] = useState(from ?? target);
  const valueRef = useRef(from ?? target);

  useEffect(() => {
    const start = performance.now();
    const origin = valueRef.current;
    let raf = 0;
    const step = (t: number) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = origin + (target - origin) * eased;
      valueRef.current = v;
      setValue(v);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return value;
}
